import React from "react";
import "./GlobalSupply.css";
import globalImg from "../assets/global.png";

const GlobalSupply = () => {
  return (
    <div className="ps-row reverse slide-in-right">
      <div className="ps-image">
        <img src={globalImg} alt="Global Services" />
      </div>

      <div className="ps-text">
        <h2>Global Supply & Export Services</h2>
        <p>
          Recla serves clients across India, Nigeria, Bhutan, Bangladesh, 
          Vietnam, the USA, and the UK.
        </p>

        <ul>
          <li>End-to-end export documentation (SONCAP, PC, etc.)</li>
          <li>Private labelling and custom branding for distributors</li>
          <li>Air & sea freight logistics with international delivery support</li>
        </ul> 
        <p className="ps-note">Your trusted printing partner worldwide.</p>
      </div>
    </div>
  );
};

export default GlobalSupply;
